import { render } from "./ProgramEditItemPane.vue?vue&type=template&id=d3b546dc&scoped=true&ts=true"
import script from "./ProgramEditItemPane.vue?vue&type=script&lang=ts"
export * from "./ProgramEditItemPane.vue?vue&type=script&lang=ts"

import "./ProgramEditItemPane.vue?vue&type=style&index=0&id=d3b546dc&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b546dc"]])

export default __exports__